import { useClientManager } from "@megaron/react-clients";
import { Serializers, SerializerValue } from "@megaron/serializers";

import { customerPresetFiltersSerializer } from "@megaron/megarax-uri";

export const listPresetColumnsSerializer = Serializers.object({
  added: Serializers.string.array(),
  removed: Serializers.string.array(),
});

export type ListPresetColumns = SerializerValue<typeof listPresetColumnsSerializer>;

export const listPresetSerializer = Serializers.object({
  filters: customerPresetFiltersSerializer,
  columns: listPresetColumnsSerializer,
});

export type ListPreset = SerializerValue<typeof listPresetSerializer>;

export const newListPreset = (): ListPreset => ({
  filters: {
    sort: undefined,
    isPro: false,
    isAffiliate: false,
    isActive: undefined,
    hasGooglePlaceId: undefined,
    pos: undefined,
    tags: undefined,
    isMyRegion: true,
    regions: undefined,
    isUnassigned: undefined,
    scannedProducts: undefined,
    status: ["unverified", "verified", "vip"],
    categories: undefined,
    parents: undefined,
    relation: undefined,
    loyaltyJoinedAtStartDate: undefined,
    loyaltyJoinedAtEndDate: undefined,
  },
  columns: { added: [], removed: [] },
});

export const useCustomersQuery = (preset: ListPreset) => {
  return useClientManager("docs")
    .searchCustomers()
    .useQuery({
      ...preset.filters,
    });
};
